import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Autocomplete from "@mui/material/Autocomplete";
import useAlert from "../../core/useAlert";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { useAppSelector } from "../../store/hooks";
import { GetSingleTimeExpenseEntryMutation } from "./mutations/GetSingleTimeExpenseEntryMutation";
import {
  Communication,
  CommunicationLogInput,
  CommunicationResourceTypeEnum,
  PositionEnum,
} from "./types";
import { useForm, Controller } from "react-hook-form";
import { getInitialValuesForUpdate } from "./GetModifiedInput";
import { GetMatterDependencyDataMutation } from "./mutations/GetMatterDependencyDataMutation";
import Loading from "../../components/Loading";
import { useMyState } from "../../utils";
import { CreateCommunicationLogMutation } from "./mutations/CreateCommunicationLogMutation";
import moment from "moment";
import { timerActions } from "../../store/timerSlice";
import {TimeExpenseEntry, } from "./types-time-entry";
import { Grid, Typography } from "@mui/material";

import { yupResolver } from "@hookform/resolvers/yup";
import { useEmail } from "../../core/MailLoader";
import { LoadingButton } from "@mui/lab";
export interface UpdateTimeEntryProps {
  onClose: () => void;
  onSave: (communication?:Communication, matterId?:string) => void;
  timeEntryId: string;
}
export interface TimeEntryInput extends TimeExpenseEntry {
  
}
export interface TimeEntryUpdateFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: TimeEntryInput) => void;
  defaultValues: TimeEntryInput;
}
 const schema = yup.object().shape({
    description: yup.string().required("Required"),
  });
const TimeEntryUpdateForm: React.FC<TimeEntryUpdateFormProps> = ({
  open,
  onClose,
  onSubmit,
  defaultValues,
}) => {
  const matters = useAppSelector(state=>state.timer.matters)
  const createEmailLogLoading = useAppSelector(state=>state.timer.createEmailLogLoading)
  const options = matters;
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    control,
  } = useForm({
    defaultValues,
    // resolver: yupResolver(schema as unknown as any),
  });
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return; // disable backdrop close
        }}
        disableEscapeKeyDown
      >
        <DialogTitle>Create Email Log</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(onSubmit)} id="time-entry-form">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Controller
                  name="matter"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={options!}
                      getOptionLabel={(option) => option?.matterTitle || ""}
                      onChange={(_, value) => field.onChange(value)} // ⭐ set RHF value
                      renderInput={(params) => (
                        <TextField {...params} label="Select matter" size="small" />
                      )}
                      
                    />
                  )}
                />
              </Grid>
              {/* <Grid item xs={12}>
                <TextField
                  {...register("description")}
                  size="small"
                  multiline
                  rows={5}
                  label="Description"
                />
                <Typography color={"error"}>{errors?.description?.message!}</Typography>
              </Grid> */}
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </Button>
          <LoadingButton loading={createEmailLogLoading} type="submit" form="time-entry-form">
            Save
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
const UpdateTimeEntry: React.FC<UpdateTimeEntryProps> = ({ onClose, onSave, timeEntryId }) => {
  const showAlert = useAlert();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(true);
  const emailData = useEmail()
  const [loading, setLoading] = useMyState<{timeEntry:boolean, dependency:boolean}>({
      timeEntry: false,
      dependency: false,
    });
  
  const {dependencyData, timeExpenseEntry:timeEntry, sendMailLoading} = useAppSelector((state) => state.timer);
  
  const defaultValues: TimeEntryInput = React.useMemo(
    () => ({
      ...getInitialValuesForUpdate(timeEntry, dependencyData),
      description: emailData.mailSubject,
    }),
    [emailData, timeEntry, dependencyData]
  );

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };
  const submit = (values: TimeEntryInput) => {
    emailData?.refetch?.()
    dispatch(timerActions.getCreateEmailLogLoading(true))
    const matterId = values?.matter?.id!;
     if(!emailData.mailSubject){
      showAlert("There is no subject in this mail", {
          variant: "error",
        });
        handleClose()
      return
    }
    if(!emailData.mailBody){
      showAlert("There is no message in Mail Body", {
          variant: "error",
        });
        handleClose()
      return
    }
   
    const input: CommunicationLogInput = {
      dateOn: moment().toISOString(),
      matterId,
      messageBody: emailData.mailBody,
      messageFrom: [emailData.mailFrom],
      messageTo: emailData.mailTo,
      resourceId: emailData?.mailId,
      resourceType: CommunicationResourceTypeEnum.EmailAddOn,
      subject: emailData.mailSubject,
    };

    dispatch(
      CreateCommunicationLogMutation(input, {
        onSuccess: (response:any) => {
          dispatch(
            timerActions.getSteps({
              step: {
                stepId: PositionEnum.CommunicationCreate,
                title: "Communication Log Created",
                subTitle: "Email log created for the matter",
                data: { ...values, ...input, resourceType:3, resourceId:response?.id! },
                component:(callback)=><LoadingButton loading={sendMailLoading} size="small" variant="contained" color={'primary'} onClick={callback}>Send Mail</LoadingButton>,
              },
              position: PositionEnum.CommunicationCreate,
            })
          );
          onSave(response, matterId);
          handleClose()
        },
        onLoading:(loading)=>dispatch(timerActions.getCreateEmailLogLoading(loading))
      })
    );
  }

  React.useEffect(() => {
    dispatch(
      GetSingleTimeExpenseEntryMutation(timeEntryId, {
        onLoading: (loading) => setLoading("timeEntry", loading),
      })
    );
  }, []);

  React.useEffect(() => {
    if (emailData?.mailTo?.length) {
      dispatch(
        GetMatterDependencyDataMutation(emailData.mailTo, {
          onLoading: (loading) => setLoading("dependency", loading),
        })
      );
    } else {
      setLoading("dependency", false);
    }
  }, [emailData?.mailTo]);

  React.useEffect(()=>{
    emailData?.refetch?.()
  },[])

  if (emailData.emailLoading || loading.dependency || loading.timeEntry)
    return <Loading />;

  return (
    <TimeEntryUpdateForm
      open={open}
      defaultValues={defaultValues}
      onClose={handleClose}
      onSubmit={submit}
    />
  );
};

export default UpdateTimeEntry;
